import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, track } from '../lib/analytics';

const AnalyticsObserver = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
    track('$pageview', { path: `${location.pathname}${location.search}` });
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleClick = (event) => {
      const link = event.target.closest('a');
      if (!link) return;
      const href = link.href || '';
      if (href.includes('calendly.com')) track('discovery_call_clicked', { path: location.pathname });
      else if (href.startsWith('mailto:')) track('email_link_clicked', { path: location.pathname });
      else if (/instagram|facebook|youtube|linkedin/.test(href)) track('social_link_clicked', { destination: href });
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [location.pathname]);

  return null;
};

export default AnalyticsObserver;
